<template>
  <profile-section
    section-title="Previewer"
    class="previewer-section"
  >
    <profile-subsection
      :show-action="false"
    >
      <template #inactive>
        <router-link
          :to="{ name: 'following#index' }"
          class="feature-link"
        >
          Go to followers page
        </router-link>
        <router-link
          :to="{ name: 'content-partners#index' }"
          class="feature-link"
        >
          Go to app content partners page
        </router-link>
        <router-link
          :to="{ name: 'mastery#history' }"
          class="feature-link"
        >
          Go to history page
        </router-link>
      </template>
    </profile-subsection>
    <profile-subsection
      :show-action="false"
    >
      <template #inactive>
        <p class="lil-header">
          Feature Flags
        </p>
        <div
          v-for="flag in featureFlags"
          :key="flag"
        >
          <input
            :id="flag"
            :checked="flagData[flag]"
            type="checkbox"
            @change="handleFlagChange"
          />
          <label :for="flag">{{ flag }}</label>
        </div>
      </template>
    </profile-subsection>
    <button @click="showProfile">
      New Profile
    </button>
  </profile-section>
</template>

<script>
import ProfileSection from '@components/profile/section';
import ProfileSubsection from '@components/profile/subsection';

export default {
  components: { ProfileSection, ProfileSubsection },
  data() {
    return {
      flagData: {},
    };
  },
  computed: {
    featureFlags() {
      return [
        'checklistWidgetEnabled',
      ];
    },
  },
  mounted() {
    this.featureFlags.forEach(flag => {
      const value = this.$apptimize.checkFeatureFlags(flag);
      this.flagData[flag] = value;
    });
  },
  methods: {
    handleFlagChange(evt) {
      const flag = evt.currentTarget.id;
      const value = evt.currentTarget.checked;
      this.flagData[flag] = value;
      this.$apptimize.addFeatureFlagOverride(flag, value);
    },
    showProfile() {
      return this.$store.dispatch('ui/setProfileModalShown', 'profileShowModal');
    },
  },
};
</script>

<style lang="scss" scoped>
.previewer-section {
  .feature-link {
    display: block;
  }

  .lil-header {
    color: #767676;
    font-size: rem-calc(14);
    font-weight: $bold;
    margin-bottom: rem-calc(8) !important;
    text-transform: uppercase;
  }
}
</style>
